module.exports = "/static/viewer/generated/images/Edar Image.webp?65388fdc6904d893efd9a9b0ea821f4e";